<template>
    <b-form v-on:submit.prevent >
        <b-form-group 
            id="fieldset-mailing-list"
            label="Recherchez un article"
            label-for="search-tool"
            size="sm"
            class="mb-4"
        >
            <b-input-group size="sm">
                <b-form-input
                    id="search-tool"
                    placeholder="Mots-clés"
                    :formatter="keywordsFormatter"
                    v-model="search.keywords"
                    @input="keywordSearch"
                    size="sm"
                ></b-form-input>
            </b-input-group>
        </b-form-group>

        <ul v-if="topics.length > 0" class="d-flex flex-column px-3">
            <li v-for="(tag, index) in topics" :key="'topic-' + index" >
                <b-link 
                    class="text-blue" 
                    @click.prevent="setTag($event, tag)"
                >{{ tag }}<span class="ml-2 text-smaller text-silver">({{ hitsPerTopic(tag) }})</span></b-link>
            </li>
        </ul>

    </b-form>
</template>

<script>
import axios from 'axios'

export default {
  props: [
      'posts',
      'topics'
  ],
  data() {
    return {
        search: {
            keywords: null,
            results: []
        }
    }
  },
  created() {
      this.$parent.$on('resetTagg', this.resetTag);
      this.$parent.$on('resetKw', this.resetKw);
  },
  methods: {
    hitsPerTopic(topic) {
        if (topic && topic !== null) {
            let hits = this.posts.filter(post => post.tags.includes(topic)).length
            if (hits > 1) return hits + ' articles'
            return hits + ' article'
        }

        return false
    },
    resetTag() {
        let activeTag = document.getElementsByClassName('active')[0]
        if (activeTag) activeTag.classList.remove('active')
        return false
    },
    resetKw() {
        this.search.keywords = null
        return false
    },
    setTag(e, tag) {
        let siblings = e.srcElement.parentElement.parentElement.children
        for (let i in siblings) {
            if (siblings[i].firstChild) siblings[i].firstChild.classList.remove('active')
        }
        e.target.classList.add('active')
        this.$emit('setTag', tag)
    },
    keywordSearch() {
        if (this.search.keywords.length > 0){
            this.$emit('search', this.search)
        } else {
            this.search.keywords = null
            this.$emit('resetKw')
        }
    },
    keywordsFormatter(string) {
        return string.toLowerCase().replace(/[^a-z\s-\d]/g, '')
    }
  }
}
</script>

<style scoped>
.btn.active {
    background-color: #003643;
}

.form-control,
input {
    border: none !important;
    color: #001216;
}

a.text-blue.active {
    color: #99e1f3 !important;
}
</style>
